<template>
  <v-dialog
    v-model="isOpen"
    max-width="700"
    @input="handleClose"
  >
    <v-card>
      <v-card-title class="headline pb-10">
        <div class="columns">
          <div class="column">
            <h2 class="title is-3">Дублировать лендинг: {{ currentApplication.package_name }}</h2>
          </div>
        </div>
      </v-card-title>

      <v-card-text>
        <v-layout column>

          <v-layout row>
            <v-layout column class="mb-4">
              <b-field label="Название лендинга">
                <b-input :value="currentApplication.package_name" disabled />
              </b-field>
            </v-layout>
            <v-layout column class="pl-2">
              <b-field label="Keitaro ID">
                <b-input :value="currentApplication.keitaro_id" disabled />
              </b-field>
            </v-layout>
          </v-layout>

          <!-- Название в адресе -->
          <b-field label="Название в адресе лендинга (новое, не должно совпадать со старым)">
            <b-input v-model="newLandingName" placeholder="Введите новый адрес" />
          </b-field>

          <!-- Владелец -->
          <b-field label="Владелец лендинга">
            <b-input :value="profileName" disabled />
          </b-field>

          <!-- Домен -->
          <b-field label="Домен лендинга">
            <b-input :value="currentApplication.domain" disabled />
          </b-field>

          <!-- Шаблон A -->
          <b-field label="Шаблон страницы A">
            <b-input :value="templateAName" disabled />
          </b-field>

          <!-- Шаблон B -->
          <b-field v-if="currentApplication.a_b_test" label="Шаблон страницы B">
            <b-input :value="templateBName" disabled />
          </b-field>

        </v-layout>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close()">Закрыть</v-btn>
        <v-btn
          text
          color="primary"
          @click="duplicateLanding()"
          :disabled="!newLandingName"
          :loading="isLoading"
        >
          Дублировать
        </v-btn>
      </v-card-actions>

      <overlay-loader :show="isLoading"></overlay-loader>
    </v-card>
  </v-dialog>
</template>

<script>
import OverlayLoader from '@/app/shared/components/app-loader/Loader';
import { toFormData } from '@/app/shared/services/helpers';

export default {
  name: 'DuplicateLandingModal',
  components: {
    OverlayLoader
  },
  data() {
    return {
      newLandingName: ''
    };
  },
  watch: {
    isOpen(newVal) {
      if (newVal && this.currentApplication) {
        // Подставляем дефолтное имя для копии
        this.newLandingName = `${this.currentApplication.landing_name || ''}_copy`;
      }
    }
  },
  computed: {
    isLoading() {
      return this.$store.getters.IS_APPLICATIONS_LOADING;
    },
    isOpen: {
      get() {
        return this.$store.getters.IS_DUPLICATE_APPLICATION_MODAL_OPENED;
      },
      set(value) {
        this.$store.commit('SET_DUPLICATE_APPLICATION_MODAL_OPENED', value);
      }
    },
    currentApplication() {
      return this.$store.getters.CURRENT_APPLICATION;
    },
    profiles() {
      return this.$store.getters.GET_PROFILES || [];
    },
    profileName() {
      if (!this.currentApplication.profile_id) return '';
      const profile = this.profiles.find(p => p.id === this.currentApplication.profile_id);
      return profile ? profile.name : '';
    },
    templates() {
      return this.$store.getters.TEMPLATES?.results || [];
    },
    templateAName() {
      if (!this.currentApplication.template_a) return '';
      const t = this.templates.find(tpl => tpl.id === this.currentApplication.template_a);
      return t ? t.name : '';
    },
    templateBName() {
      if (!this.currentApplication.template_b) return '';
      const t = this.templates.find(tpl => tpl.id === this.currentApplication.template_b);
      return t ? t.name : '';
    }
  },
  methods: {
    handleClose(isOpen) {
      if (!isOpen) {
        this.close();
      }
    },
    close() {
      this.isOpen = false;
      this.newLandingName = '';
    },
    async duplicateLanding() {
      if (!this.newLandingName) {
        this.$toast.warning('Введите название в адресе лендинга');
        return;
      }

      this.$store.dispatch('DUPLICATE_APPLICATION', {
        id: this.currentApplication.id,
        landing_name: this.newLandingName
      })
        .then(() => {
          this.$toast.success('Лендинг успешно дублирован!');
          this.$emit('landing-duplicated');
          this.close();
        })
        .catch((error) => {
          const exception = error?.response?.data?.exception;
          switch (exception) {
            case 'LandingNameAlreadyExists':
              this.$toast.warning('Уже существует лендинг с данным адресом');
              break;
            default:
              this.$toast.error('Не удалось дублировать лендинг');
              break;
          }
        });
    }
  }
};
</script>